import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError, map } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  private apiUrl = environment.api.url;

  token: string;
  constructor(
    private store: Store,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  authorize() {
    const url = `${this.apiUrl}/oauth/google/redirect`;

    this.authService.token().subscribe((token) => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': 'en',
        Authorization: `Bearer ${this.token}`, // Use the token here
      }),
    };

    return this.http.get<any>(url, httpOptions).pipe(
      map((response) => {
        if (!response) {
          // If the token is not present in the response, throw an error
          throw new Error('Login failed: No token received');
        }

        return {
          url: response.data,
        };
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  callback(code, user_id) {
    const url = `${this.apiUrl}/oauth/google/callback`;

    this.authService.token().subscribe((token) => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': 'en',
        Authorization: `Bearer ${this.token}`, // Use the token here
      }),
    };

    return this.http.post<any>(
      url,
      { code: code, user_id: user_id },
      httpOptions
    );
  }

  logout(user_id: number) {
    const url = `${this.apiUrl}/oauth/google/disconnect`;

    this.authService.token().subscribe((token) => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': 'en',
        Authorization: `Bearer ${this.token}`, // Use the token here
      }),
    };

    return this.http.post<any>(url, { user_id: user_id }, httpOptions);
  }

  getGmails(email: any, page: any = 1) {
    const url =
      `${this.apiUrl}/oauth/google/gmails?email=` + email + '&page=' + page;

    this.authService.token().subscribe((token) => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': 'en',
        Authorization: `Bearer ${this.token}`, // Use the token here
      }),
    };

    return this.http.get<any>(url, httpOptions).pipe(
      map((response) => {
        if (!response) {
          // If the token is not present in the response, throw an error
          throw new Error('Get Gmails failed: No gmails received');
        }
        return {
          data: response.data,
        };
      }),
      catchError((error) => {
        throw error;
      })
    );
  }
}
